import { MAX_BATCH_SIZE_IN_KB } from "@/cache/CustomGeoJSONCache/lineStringFeatureConst";
import { chunkLineString } from "@/threads/DataProcessingThread/utils/custom-geojson/chunkLineString";
import { chunkLineStringFeatureArrayByMaxSize } from "@/threads/DataProcessingThread/utils/custom-geojson/chunkLineStringFeatureArrayByMaxSize";
import type { Units } from "@mm/metx-workbench.meteomatics.com";
import type { Feature, GeoJsonProperties, LineString } from "geojson";

export const chunkAndBatchesLineString = (
  lineStringFeatures: Array<Feature<LineString, GeoJsonProperties>>,
  segmentLength: number,
  units: Units,
) => {
  // split into chunks by length resolution
  const featuresLinesString = chunkLineString(lineStringFeatures, segmentLength, units);
  return chunkLineStringFeatureArrayByMaxSize(featuresLinesString.features, MAX_BATCH_SIZE_IN_KB);
};
